// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Idea","backBtn":"styles_backBtn__1GQte"};